import angular from 'angular';

import SelecaoEntidadeController from './entidade/selecao/selecao-entidade.controller';
import EntidadeContextoHolderService from './entidade/entidade-contexto-holder.service';
import EntidadeContextoManagerService from './entidade/entidade-contexto-manager.service';

import SelecaoSistemaController from './sistema/selecao/selecao-sistema.controller';
import SistemaContextoManagerService from './sistema/sistema-contexto-manager.service';
import SistemaContextoHolderService from './sistema/sistema-contexto-holder.service';

import SelecaoSubcontextoController from './subcontexto/selecao/selecao-subcontexto.controller';
import SubcontextoContextoManagerService from './subcontexto/subcontexto-contexto-manager.service';
import SubcontextoContextoHolderService from './subcontexto/subcontexto-contexto-holder.service';

import MenuSelecaoContextoService from './menu/menu-selecao-contexto.service';
import MenuSelecaoContextoDirective from './menu/menu-selecao-contexto.directive';

import AcessoContextoHolder from './common/acesso-contexto-holder.service';
import AcessoService from './common/acesso.service';
import AppContextService from './common/app-contexto.service';
import LicencaService from './common/licenca.service';
import SubcontextoOrderByDefaultAndAlphabetically from './common/subcontexto-order.filter';

const contexto = angular.module('contexto', [])
  .controller('SelecaoEntidadeController', SelecaoEntidadeController)
  .controller('SelecaoSistemaController', SelecaoSistemaController)
  .controller('SelecaoSubcontextoController', SelecaoSubcontextoController)
  .service('EntidadeContextoHolderService', EntidadeContextoHolderService)
  .service('EntidadeContextoManagerService', EntidadeContextoManagerService)
  .service('SistemaContextoManagerService', SistemaContextoManagerService)
  .service('SistemaContextoHolderService', SistemaContextoHolderService)
  .service('SubcontextoContextoManagerService', SubcontextoContextoManagerService)
  .service('SubcontextoContextoHolderService', SubcontextoContextoHolderService)
  .service('MenuSelecaoContextoService', MenuSelecaoContextoService)
  .directive('menuSelecaoContexto', MenuSelecaoContextoDirective)
  .service('AcessoService', AcessoService)
  .service('AcessoContextoHolderService', AcessoContextoHolder)
  .service('LicencaService', LicencaService)
  .service('AppContextService', AppContextService)
  .filter('subcontextoOrder', SubcontextoOrderByDefaultAndAlphabetically);

export default contexto;
